import useHttpClient from "hooks/useHttpClient";
import { useQuery } from "react-query";

function useHotStockQuery() {
  const httpClient = useHttpClient();
  return useQuery({
    queryKey: ["stock-hotstocks"],
    queryFn: async () => {
      const { data: queryResult } = await httpClient.get(`/stock/hot`);
      return queryResult?.data;
    },
  });
}

function useDailyHotQuery() {
  const httpClient = useHttpClient();
  return useQuery({
    queryKey: ["stock-daily_hot"],
    queryFn: async () => {
      const { data: queryResult } = await httpClient.get(`/stock/daily_hot`);
      return queryResult?.data?.stocks;
    },
  });
}

function useStockTraderStatsQuery(stockCode) {
  const httpClient = useHttpClient();
  return useQuery({
    queryKey: ["stock-trader_stats", stockCode],
    queryFn: async () => {
      const { data: queryResult } = await httpClient.get(
        `/stock/ranker_stats?code=${stockCode}`
      );
      return queryResult?.data;
    },
  });
}

export { useDailyHotQuery, useHotStockQuery, useStockTraderStatsQuery };
